import styled, { keyframes } from '@xstyled/styled-components';
// Pulsing green outline animation: quick pulse, then slow pulse, repeat
const pulseGreen = keyframes`
  0% {
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5), 0 0 0 0px rgba(34,197,94,0.7);
  }
  10% {
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5), 0 0 0 8px rgba(34,197,94,0.3);
  }
  20% {
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5), 0 0 0 0px rgba(34,197,94,0.7);
  }
  70% {
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5), 0 0 0 8px rgba(34,197,94,0.3);
  }
  100% {
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5), 0 0 0 0px rgba(34,197,94,0.7);
  }
`;
import PhoneImage from './iPhone.png';
import phoneBg from './phone-bg.png';
import btnAccept from './btn-accept.png';
import btnAcceptHover from './btn-accept-hover.png';
import { drillAnimation } from '~/ui/animation';
import {
  PHONE_FRAME_HEIGHT_PX,
  PHONE_FRAME_WIDTH_PX
} from './phoneReflowLayout';

export const PhoneBackground = styled.div`
  background-image: url(${PhoneImage});
  position: absolute;
  width: 300px;
  height: 580px;
  z-index: 1;
`;

export const WrapperForChildren = styled.div`
  div:first-child {
    position: relative;
    height: 285px;
    width: 254px;
    height: 547px;
    top: 0;
    left: 0px;
    z-index: 1;
    border-radius: 10px;
  }
  div:nth-child(2) {
    div:nth-child(1) {
      display: none;
    }
  }
`;

export const Phone = styled.div`
  background: url(${phoneBg}) no-repeat 50% 50% / cover;
  position: relative;
  width: ${PHONE_FRAME_WIDTH_PX}px;
  height: ${PHONE_FRAME_HEIGHT_PX}px;
  padding: 80px 50px 100px;
`;

export const UserName = styled.div`
  font-size: 18px;
  color: #fff;
`;

export const UserLabel = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.66);
  margin-top: -3px;
`;

export const CallButton = styled.button`
  background: url(${btnAccept}) no-repeat 50% 50% / cover;
  position: absolute;
  top: 427px;
  left: 216px;
  width: 50px;
  height: 50px;
  border: 1.5px solid #fff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
  border-radius: 50%;
  transition: all ease-in-out 0.3s;
  animation: ${pulseGreen} 2.2s infinite;
`;

export const ProgressWrapper = styled.div`
  position: absolute;
  bottom: 50px;
  left: 30px;
  right: 30px;
`;
